export const getErrorSetup = (error: any) => {
    const errorSetup = {
        message: error.response?.data?.errors?.[0]?.errorMessage ?? "Unknown error message",
        code: error.response?.status ?? 500,
        codeConfig: error.response?.data?.errors?.[0]?.errorCode ?? "UNKNOWN_ERROR_CODE",
    };
    return errorSetup;
};